import { z } from 'zod/v4';

export const AcceptUserTermsBodySchema = z.object({
  hasAgreedWithTerms: z.boolean(),
});

export type AcceptUserTermsBody = z.infer<typeof AcceptUserTermsBodySchema>;
